import React from 'react'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { patternThumbs, swatchTexture } from '../textures'


const ColorSwatchCircle = ({ src = null, tag = null, color = null, handleClick = null, section = null, texture = true }) => {

    console.log("texture", texture)
    let activeColor
    const snap = useSnapshot(state.current)

    if (section === "ribs") {
        // console.log("ribs")
        activeColor = snap.choices.ribs.selected.rib[snap.status.currentRib - 1].name
        // console.log(activeColor)

    } else if (section === "raceNumber") {

        if (snap.status.numberSelectMode === "outline") {
            activeColor = snap.choices[section].selected.outlineName || null
        } else {
            activeColor = snap.choices[section].selected.name || null
        }


    } else {

        if (snap.choices[section].selected.name !== null) {
            activeColor = snap.choices[section].selected.name || null
        }

    }


    return (
        <Wrap>

            <Circle
                $isActive={activeColor === tag}
                $texture={texture}
                style={src ? { backgroundImage: `url("${patternThumbs[src]}")` } : { background: color }} onClick={handleClick}>
            </Circle>
            {/* <Tag>{tag}</Tag> */}
        </Wrap>
    )
}

export default ColorSwatchCircle

const Tag = styled.div`
opacity: 0;
font-size: 14px;
text-align: center;
width: 40px;
word-break: keep-all;
transition: .6s all;
position: absolute;
display: flex;
justify-content: center;
overflow-wrap: normal;
align-items: center;
line-height: 1;
`


const Wrap = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
display: block;
transition-delay: all 0s;
transition: all 0.4s;
position: relative;

&:hover ${Tag} {
    opacity: 1;   
}

&.active-choice ${Tag} {
    opacity: 1;
}
`
const Circle = styled.div`
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50% ;
    cursor: pointer;
    position: relative;
    background-size: cover;
    z-index: 1;
    
      filter: ${props => props.$isActive ? "drop-shadow(0 2px 2px var(--highlight-colorfade))" : "none"} ;
    outline: ${props => props.$isActive ? "2px solid var(--highlight-color)" : "none"} ;
    outline-offset: 4px;
        
    &::after {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border-radius: 50%;
        position: absolute;
        content: "";
        /* background-image: url(${swatchTexture.texture}); */
         background-image: ${props => props.$texture ? `url(${swatchTexture.texture})` : "none"} ;
        background-size: 50%;
        background-blend-mode: lighten;
        opacity: 0.3;
    }

    @media (width > 800px) {
      width: min(4vw, 35px);
      height: min(4vw, 35px);
  }`








